var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "p-0" },
    [
      _c("SPopUp", {
        staticClass: "popUp",
        attrs: {
          "data-cy": "popup-error",
          isOpen: _vm.errorPopUp,
          sText: _vm.$t("label.teams.selected.errorPopUp"),
          isValid: !_vm.errorPopUp,
        },
        on: { close: _vm.handleClosePopUp },
      }),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "px-0", attrs: { cols: "12" } },
            [
              _c("SButton", {
                staticClass: "mb-2",
                attrs: {
                  sText: _vm.$t("sModalNewClientCreator.addNewClientBtn"),
                  btnStyle: "secondary",
                  action: _vm.openNewClientModal,
                },
              }),
              _vm._v(" "),
              _c("SSelectorMultiple", {
                attrs: {
                  mode: "floatingLabel",
                  label: _vm.$t("requests-filter-list.filter.clients"),
                  items: _vm.clientItems,
                  "data-cy": "filter-company-selector",
                  autocomplete: "",
                },
                model: {
                  value: _vm.selectedClients,
                  callback: function ($$v) {
                    _vm.selectedClients = $$v
                  },
                  expression: "selectedClients",
                },
              }),
              _vm._v(" "),
              _c("SModalNewClientCreator", {
                attrs: {
                  isOpen: _vm.isNewClientModalOpen,
                  onClose: _vm.closeNewClientModal,
                  action: _vm.addNewClient,
                },
              }),
              _vm._v(" "),
              _vm.selectedClients.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "mt-2 pl-3 pr-2",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "4px",
                      },
                    },
                    _vm._l(_vm.selectedClients, function (clientId) {
                      return _c(
                        "div",
                        { key: clientId, staticClass: "selected-client-row" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-body-1-medium text--text text--base",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.clientItems.find(
                                      (item) => item.id === clientId
                                    )?.desc || clientId
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "delete-trash",
                            on: {
                              click: function ($event) {
                                return _vm.removeSelectedClient(clientId)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "16px",
                  },
                },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label: _vm.$t(
                        "checkout.buttonGroup.manager.checkout.checkbox"
                      ),
                    },
                    model: {
                      value: _vm.createApprovedTeamRequestCheckBox,
                      callback: function ($$v) {
                        _vm.createApprovedTeamRequestCheckBox = $$v
                      },
                      expression: "createApprovedTeamRequestCheckBox",
                    },
                  }),
                  _vm._v(" "),
                  _vm.createApprovedTeamRequestCheckBox
                    ? _c("v-checkbox", {
                        staticClass: "ml-2",
                        attrs: {
                          label: _vm.$t(
                            "checkout.buttonGroup.manager.checkout.skipMail"
                          ),
                        },
                        model: {
                          value: _vm.notifyClientByEmailCheckbox,
                          callback: function ($$v) {
                            _vm.notifyClientByEmailCheckbox = $$v
                          },
                          expression: "notifyClientByEmailCheckbox",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("SButton", {
                attrs: {
                  sText: _vm.$t(
                    "checkout.buttonGroup.manager.checkout.request"
                  ),
                  btnStyle: "primary",
                  action: () => _vm.openTeamRequestConfirmationModal(),
                  disabled: _vm.selectedClients.length === 0,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SModalTeamRequestConfirmation", {
        attrs: {
          teamRequest: _vm.teamRequest,
          isOpen: _vm.isTeamRequestConfirmationModalOpen,
          onClose: _vm.closeTeamRequestConfirmationModal,
          action: _vm.onClickTeamRequestConfirmationModal,
          loading: _vm.loadingTeamRequest,
          customProps: {
            title: "sModalTeamRequestConfirmation.title",
            primaryButtonText: "sModalTeamRequestConfirmation.label.confirmBtn",
            initDateRequired: true,
            endDateRequired: false,
          },
        },
      }),
      _vm._v(" "),
      _c("SModalStemdoerNotAvailable", {
        attrs: {
          stemdoers: _vm.stemdoersNotAvailables,
          isOpen: _vm.isStemdoersNotAvailableModalOpen,
          onClose: _vm.closeStemdoersNotAvailableModal,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }